import { DomainError, type MutationResult } from '../domain/model';
import { acknowledge, eventsFor, retainProblem, withSyncLock, type StoredEvent } from './local';

export async function drainEvents(scope: string, send: (event: StoredEvent) => Promise<MutationResult>, isCurrent = () => true): Promise<number> {
  return await withSyncLock(scope, async () => {
    let sent = 0;
    for (const event of await eventsFor(scope)) {
      if (!isCurrent()) break;
      if (event.state !== 'pending') continue;
      try {
        const result = await send(event);
        if (result.status === 'applied' || result.status === 'duplicate') { await acknowledge(event); sent++; }
      } catch (error) {
        if (error instanceof DomainError && (error.code === 'conflict' || error.code === 'invalid')) {
          await retainProblem(event, error.code, error.message);
        } else throw error;
      }
    }
    return sent;
  }) ?? 0;
}
